import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { process } from '@progress/kendo-data-query';
import { eButtonActions, eFeatures, eUserRole } from '../../../models/enum.model';
import { MailMergeTemplateDropDown, EngageSC, EngageSCResponse } from '../../../models/repSettings.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { GridColumnsConfigurationService } from '../../../services/gridColumnsConfiguration.service';
import { NotificationService } from '../../../services/notification.service';
import { RepSettingService } from '../../../services/repSettings.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { SignupService } from '../../../services/signup.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { GlobalService } from '../../../services/global.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DropDownItem } from '../../../models/genericResponse.model';

@Component({
    selector: 'app-rep-settings',
    templateUrl: './rep-settings.component.html',
    styleUrls: ['./rep-settings.component.css'],
    providers: [GridConfigurationService]
})
/** rep-settings component*/
export class RepSettingsComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    repSettingsDataSource: MatTableDataSource<any>;
    repSettingsDataDisplayColumns: string[];
    gridHeight;
    user: CLPUser;
    public repSettingsData: EngageSC[];
    public initRepSettingsData: EngageSC[];
    repSettingResponse: EngageSCResponse
    showSpinner: boolean = false;
    columns = [
        { field: '$', title: '', width: '40' },
        { field: 'contractName', title: 'Contract', width: '200' },
        { field: 'mailMergeTemplateID', title: 'Mail Merge Template', width: '200' },
        { field: 'action', title: 'Action', width: '200' },
        { field: 'isConnectwithUser', title: 'Connect with user', width: '200' },
    ];
    reorderColumnName: string = 'contractName,mailMergeTemplateID';
    userResponse: UserResponse;
    columnWidth: string = 'contractName:200,mailMergeTemplateID:200';
    arrColumnWidth: any[] = ['contractName:200,mailMergeTemplateID:200'];
    roleFeaturePermissions: RoleFeaturePermissions;
    private editedRowIndex: number;
    private encryptedUser: string = '';
    public formGroup: FormGroup;
    repSettingForm: FormGroup
    mobileColumnNames: string[];
    repSettingFormSetup(): FormGroup {
        return new FormGroup({
            contractName: new FormControl('', [Validators.required]),
            mailMergeTemplateID: new FormControl("0"),
            emailTemplateID: new FormControl("0"),
            engageScId: new FormControl(0),
            isConnectwithUser: new FormControl(false)
        });
    }
    isEnableEdit: boolean = false;
    public mailMergeTemplateDropDown: MailMergeTemplateDropDown[];
    public emailTemplateDropDown: DropDownItem[];
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

    buttonTypeOperation: eButtonActions = eButtonActions.None;
    constructor(public _gridCnfgService: GridConfigurationService, public _localService: LocalService, private _utilityService: UtilityService, private _router: Router, private _notifyService: NotificationService, private _globalService: GlobalService, public _signupService: SignupService,
        private _repSettingService: RepSettingService, public _gridColumnsConfigurationService: GridColumnsConfigurationService) {
        this._localService.isMenu = true;
        this.gridHeight = this._localService.getGridHeight('493px');
    }

    ngOnInit(): void {
        this.repSettingForm = this.repSettingFormSetup();
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        if (this.user?.cLPCompanyID == 0 || this.user?.slurpyUserId > 0) {
                            this.getRepSettingList();
                            //Kendo grid load call stopped.
                            //this.getGridConfiguration();
                        } else
                            this._router.navigate(['/unauthorized'], { state: { isMenu: true } });

                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.EngageRepSettings, ":PP")
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this._gridCnfgService.user = this.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("repSettings.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'rep_setting_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('rep_setting_grid').subscribe((value) => { }));
    //}

    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'rep_setting_grid').subscribe((value) => this.getGridConfiguration());
    //}

    async getRepSettingList() {
        this.showSpinner = true;
        this.isEnableEdit = false;
        await this._repSettingService.getRepSettingList(this.encryptedUser, 0, 0)
            .then(async (result: EngageSCResponse) => {
                if (result) {
                    this.repSettingResponse = UtilityService.clone(result);
                    this.repSettingsData = this.repSettingResponse.engageSC

                    this.initRepSettingsData = this.repSettingResponse.engageSC
                    this.mailMergeTemplateDropDown = this.repSettingResponse.mailMergeTemplateDropDown;
                    this.emailTemplateDropDown = this.repSettingResponse.emailTemplateDropDown;
                    //if (!isNullOrUndefined(this._gridCnfgService)) {
                    //    this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('rep_setting_grid');
                    //    this._gridCnfgService.iterateConfigGrid(this.repSettingResponse, "rep_setting_grid");
                    //}
                    this.setGrid(this.repSettingsData);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }
    private closeEditor(grid, rowIndex = this.editedRowIndex) {
        grid.closeRow(rowIndex);
        this.editedRowIndex = undefined;
        this.formGroup = undefined;
    }

    public editHandler(rowIndex, dataItem) {
        this.repSettingForm.controls.contractName.setValue(dataItem?.contractName)
        this.repSettingForm.controls.mailMergeTemplateID.setValue(dataItem?.mailMergeTemplateID)
        this.repSettingForm.controls.engageScId.setValue(dataItem?.engageSCID)
        this.repSettingForm.controls.isConnectwithUser.setValue(dataItem?.isConnectwithUser)
        this.isEnableEdit = true;
        this.editedRowIndex = rowIndex;
    }

    public cancelHandler(rowIndex) {
        this.formGroup = null;
        this.editedRowIndex = -1;
    }

    public cancelRep() {
        this.formGroup = null
        this.isEnableEdit = false;
    }

    public convertEmailTemplate(templateId) {
        let templateName = this.repSettingsData?.filter((data) => data.mailMergeTemplateID === templateId)[0];
        return templateName ? templateName.mailMergeTemplateName : null;
    }

    public saveHandler(dataItem): void {
        this.showSpinner = true;
        let repSettingsField: EngageSC = <EngageSC>{};
        repSettingsField.engageSCID = dataItem.engageSCID
        repSettingsField.contractName = dataItem.contractName
        repSettingsField.mailMergeTemplateID = dataItem.mailMergeTemplateID
        repSettingsField.emailTemplateID = dataItem.emailTemplateID
        repSettingsField.isConnectwithUser = dataItem.isConnectwithUser
        this._repSettingService.updateRepSettings(this.encryptedUser, repSettingsField)
            .then(async (result: EngageSCResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.getRepSettingList();
                    this.editedRowIndex = -1;
                    this._notifyService.showSuccess(response.messageString ? response.messageString : "Rep Setting Updated Successfully.", "", 3000);
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    addNew() {
        this.isEnableEdit = true;
        this.repSettingForm = this.repSettingFormSetup();
    }

    repSettingFormSubmit() {
        this.repSettingForm.controls.contractName.markAsTouched();
        this.repSettingForm.controls.mailMergeTemplateID.markAsTouched();
        if (this.repSettingForm.valid && this.repSettingForm.controls.mailMergeTemplateID.value != 0) {
            this.showSpinner = true;
            this.buttonTypeOperation = eButtonActions.Save;
            this._repSettingService.updateRepSettings(this.encryptedUser, this.repSettingForm.value)
                .then(async (result: EngageSCResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        this.buttonTypeOperation = eButtonActions.None;
                        this.getRepSettingList();
                        this._notifyService.showSuccess(response.messageString ? response.messageString : "Rep Setting Saved Successfully.", "", 3000);
                    }
                    else {
                        this.buttonTypeOperation = eButtonActions.None;
                        this.showSpinner = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this.buttonTypeOperation = eButtonActions.None;
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    get repSettingFrm() {
        return this.repSettingForm.controls;
    }

    onRepSettingFilter(inputValue: string): void {
        //this.repSettingsData = process(this.initRepSettingsData, {
        //    filter: {
        //        logic: "or",
        //        filters: [
        //            { field: 'engageSCID', operator: 'contains', value: inputValue },
        //            { field: 'contractName', operator: 'contains', value: inputValue }
        //        ],
        //    }
        //}).data;
        //this.dataBinding.skip = 0;
        inputValue = inputValue.trim().toLowerCase();

        if (this.repSettingsDataSource) {
            this.repSettingsDataSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.repSettingsDataSource.filter = inputValue;
        }
    }

    setGrid(list) {
        this.repSettingsDataDisplayColumns = this.columns.map(c => c.field);
        this.repSettingsDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.repSettingsDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('rep_setting_grid') ? this._localService.getPageSize('rep_setting_grid') : 50;
            }
            if (this.sort) {
                this.repSettingsDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('rep_setting_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
